const ROUTE_VIEW_MESSAGE = [
  // 消息提醒
  { path: '/messageDetail', name: '消息提醒', h5Uri: '/message/messageDetail', nativeUri: null, whiteList: false },
  // iframe
  { path: '/iframe', name: '外链', h5Uri: '/message/webpage', nativeUri: null, whiteList: true }
]

export default ROUTE_VIEW_MESSAGE



// WEBPACK FOOTER //
// ./src/router/mapping/message.js